import {
    CertificateDataCorrupted as CertificateDataCorrupted_1,
    CertificateTimeInvalid as CertificateTimeInvalid_1,
    CertificateValidPeriodNotNested as CertificateValidPeriodNotNested_1,
    CertificateRevoked as CertificateRevoked_1,
    SignatureInvalid as SignatureInvalid_1,
    CertificateInvalidForUsage as CertificateInvalidForUsage_1,
    RootCertificateNotTrusted as RootCertificateNotTrusted_1,
    RevocationStatusUnknown as RevocationStatusUnknown_1,
    CyclicCertificateChainError as CyclicCertificateChainError_1,
    CertificateExtensionInvalid as CertificateExtensionInvalid_1,
    InvalidPolicyConstraints as InvalidPolicyConstraints_1,
    InvalidBasicConstraints as InvalidBasicConstraints_1,
    InvalidNameConstraints as InvalidNameConstraints_1,
    UnsupportedNameConstraint as UnsupportedNameConstraint_1,
    UndefinedNameConstraint as UndefinedNameConstraint_1,
    ForbiddenNameConstraint as ForbiddenNameConstraint_1,
    HasExcludedNameConstraint as HasExcludedNameConstraint_1,
    PartialCertificateChainError as PartialCertificateChainError_1,
    CtlTimeInvalid as CtlTimeInvalid_1,
    CtlSignatureInvalid as CtlSignatureInvalid_1,
    CtlInvalidForUsage as CtlInvalidForUsage_1,
    OfflineRevocation as OfflineRevocation_1,
    NoIssuanceChainPolicy as NoIssuanceChainPolicy_1,
} from './getSmimeSignatureStatusFlagToErrorMessageDictionary.locstring.json';
import loc from 'owa-localize';
import X509ChainStatusFlags from '../store/schema/X509ChainStatusFlags';

// S/MIME Signature ServerVerificationResult Error flag to error message map
const getSmimeSignatureStatusFlagToErrorMessageDictionary = () => ({
    [X509ChainStatusFlags.CertificateDataCorrupted]: loc(CertificateDataCorrupted_1),
    [X509ChainStatusFlags.CertificateTimeInvalid]: loc(CertificateTimeInvalid_1),
    [X509ChainStatusFlags.CertificateValidPeriodNotNested]: loc(CertificateValidPeriodNotNested_1),
    [X509ChainStatusFlags.CertificateRevoked]: loc(CertificateRevoked_1),
    [X509ChainStatusFlags.SignatureInvalid]: loc(SignatureInvalid_1),
    [X509ChainStatusFlags.CertificateInvalidForUsage]: loc(CertificateInvalidForUsage_1),
    [X509ChainStatusFlags.RootCertificateNotTrusted]: loc(RootCertificateNotTrusted_1),
    [X509ChainStatusFlags.RevocationStatusUnknown]: loc(RevocationStatusUnknown_1),
    [X509ChainStatusFlags.CyclicCertificateChainError]: loc(CyclicCertificateChainError_1),
    [X509ChainStatusFlags.CertificateExtensionInvalid]: loc(CertificateExtensionInvalid_1),
    [X509ChainStatusFlags.InvalidPolicyConstraints]: loc(InvalidPolicyConstraints_1),
    [X509ChainStatusFlags.InvalidBasicConstraints]: loc(InvalidBasicConstraints_1),
    [X509ChainStatusFlags.InvalidNameConstraints]: loc(InvalidNameConstraints_1),
    [X509ChainStatusFlags.UnsupportedNameConstraint]: loc(UnsupportedNameConstraint_1),
    [X509ChainStatusFlags.UndefinedNameConstraint]: loc(UndefinedNameConstraint_1),
    [X509ChainStatusFlags.ForbiddenNameConstraint]: loc(ForbiddenNameConstraint_1),
    [X509ChainStatusFlags.HasExcludedNameConstraint]: loc(HasExcludedNameConstraint_1),
    [X509ChainStatusFlags.PartialCertificateChainError]: loc(PartialCertificateChainError_1),
    [X509ChainStatusFlags.CtlTimeInvalid]: loc(CtlTimeInvalid_1),
    [X509ChainStatusFlags.CtlSignatureInvalid]: loc(CtlSignatureInvalid_1),
    [X509ChainStatusFlags.CtlInvalidForUsage]: loc(CtlInvalidForUsage_1),
    [X509ChainStatusFlags.OfflineRevocation]: loc(OfflineRevocation_1),
    [X509ChainStatusFlags.NoIssuanceChainPolicy]: loc(NoIssuanceChainPolicy_1),
});

export default getSmimeSignatureStatusFlagToErrorMessageDictionary;
